import { TFunction } from 'i18next'

import { ReactComponent as DownloadIcon } from '@/assets/images/icons/general/download-cloud-01.svg'
import { Button } from '@/ui'
import { PreviewErrorHandlerContainer } from './Styles'

interface PreviewErrorHandlerProps {
  errorType: 'unsupported' | 'error'
  fileType: string
  t: TFunction
  handleDownload: () => Promise<void> | undefined
}

const PreviewErrorHandler = ({
  errorType,
  fileType,
  t,
  handleDownload,
}: PreviewErrorHandlerProps) => {
  return (
    <PreviewErrorHandlerContainer
      flexDirection="column"
      justifyContent="center"
      noMargin
      alignItems="center">
      <div>
        {errorType === 'error' && (
          <>
            <h2>{t('Error')}</h2>
            <p>{t('An error occurred while loading the file.')}</p>
          </>
        )}
        {errorType === 'unsupported' && (
          <>
            <h2>{t('Unsupported file type')}</h2>
            <p>
              {t("Unfortunately, it isn't possible to preview")} .{fileType}{' '}
              {t('files. ')}
            </p>
          </>
        )}

        <p>
          {t(
            'By pressing the button below, you can download the file and view it on your computer.',
          )}
        </p>
      </div>

      <Button
        onClick={handleDownload}
        leftIcon={<DownloadIcon />}
        content={t('Download')}
      />
    </PreviewErrorHandlerContainer>
  )
}

export default PreviewErrorHandler
